import { useEffect, useState } from 'react';
import { useAppSelector } from 'redux-state/configure-store';
import { IModuleConfig } from 'redux-state/layout/types.modules';
import { ModuleConfigDiff } from 'utilities/diffs/module.config';
import { DataUrlModuleType } from './types';

export const getDataUrlModuleData = ({
  oldModuleConfig,
  dataUrlObj,
}: {
  oldModuleConfig: IModuleConfig;
  dataUrlObj: DataUrlModuleType;
}) => {
  const lookupKey = oldModuleConfig.dataUrl;
  if (lookupKey && dataUrlObj) {
    const lookupObj = dataUrlObj[lookupKey];
    if (lookupObj) {
      const { data } = lookupObj;
      if (data) {
        return { ...oldModuleConfig, ...data };
      }
    }
  }
  return oldModuleConfig;
};

/**
 * Checks if module data has already loaded if so merge and reuse. Avoid making multiple requests
 * Do not use this hook in multiple nested components as will cause multiple re-renders
 */
export const HasConfigDataUrlHook = ({ config }: { config: IModuleConfig }) => {
  /** Have to update when module changes so use module config diff otherwise may not update when module updates or infinate re-renders */
  const [newConfig] = ModuleConfigDiff({ config: [config] });
  const [moduleConfig, setModuleConfig] = useState<IModuleConfig>(config);
  const dataUrlProps = useAppSelector((state) => state.MODULE_DATA_URLS[newConfig.dataUrl ?? 'N/A']);
  const [merged, setMerged] = useState<boolean>();

  useEffect(() => {
    if (dataUrlProps?.data) {
      /** We aleady have data, merge if not already done so */
      if (!newConfig.dataUrlMerged) {
        setModuleConfig({ ...newConfig, ...dataUrlProps.data, dataUrlMerged: true });
        setMerged(true);
        return;
      }
    }
    setModuleConfig(newConfig);
    setMerged(false);
  }, [newConfig, dataUrlProps]);

  return { moduleConfig, merged };
};
